// Copyright 2025. WebPros International GmbH. All rights reserved.

import React from 'react';
import { IBackupResponse } from 'common/api/resources/Backup';
import { StyledTable } from 'common/modules/computeResourceVm/components/RestoreBackupInfo/Styles';
import {
    Action,
    Alert,
    Translate,
} from '@plesk/ui-library';
import { formatTableDate } from 'common/date';
import { isAdminSite } from 'common/helpers/core';
import CopyText from 'common/containers/CopyText/CopyText';
import { Link } from 'react-router-dom';

interface IRestoreBackupInfoProps {
    backup: IBackupResponse;
}

const RestoreBackupInfo: React.FC<IRestoreBackupInfoProps> = function ({ backup }) {

    const pathToVm = React.useMemo(
        () => isAdminSite()
            ? `/admin/servers/${backup.compute_resource_vm!.id}`
            : `/projects/${backup.compute_resource_vm!.project!.id}/servers/${backup.compute_resource_vm!.id}`,
        [backup]
    );

    return (
        <Alert intent={'info'} data-cy={'restore-backup-info'}>
            <div style={{ marginBottom: 5 }}>
                <Translate content={'servers.create.restoreBackupInfo.title'} />
            </div>

            <StyledTable>
                <tbody>
                    <tr>
                        <th><Translate content={'servers.create.restoreBackupInfo.sourceVMName'} />:</th>
                        <td>
                            <Action
                                component={Link}
                                to={pathToVm}
                            >
                                {backup.compute_resource_vm!.name}
                            </Action>
                        </td>
                    </tr>
                    <tr>
                        <th><Translate content={'servers.create.restoreBackupInfo.sourceVMUuid'} />:</th>
                        <td>
                            <CopyText style={{ marginLeft: 5 }}>
                                {backup.compute_resource_vm!.uuid}
                            </CopyText>
                        </td>
                    </tr>
                    <tr>
                        <th><Translate content={'servers.create.restoreBackupInfo.backupCreationDate'} />:</th>
                        <td>{formatTableDate(backup.created_at)}</td>
                    </tr>
                    <tr>
                        <th><Translate content={'servers.create.restoreBackupInfo.backupSize'} />:</th>
                        <td>{`${backup.disk} GiB`}</td>
                    </tr>
                </tbody>
            </StyledTable>
        </Alert>
    );
};

export default RestoreBackupInfo;
